import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import MessageBox from '../../../Common/MessageBox';
import {Button, ButtonGroup, PageContainer, PageTitle} from '../../../Common/PageComponents';
import '../../../MemberService/MemberService.scss';

export class WithdrawalCompletion extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="회원탈퇴" data-qa="usagePageTitle" />
        <div className="membership-completion">
          <div className="membership-completion__title">
            라이엇 게임즈 프리미엄 PC방
            <span className="membership-completion__subtitle">회원 탈퇴가 완료되었습니다.</span>
          </div>

          <div className="membership-completion__description">
            그 동안 라이엇 게임즈 프리미엄 PC방 서비스를 이용해주셔서 감사드리며,
            <br /> 앞으로도 더 향상된 서비스를 제공할 수 있도록 최선을 다하겠습니다.
          </div>
          <MessageBox className="membership-completion__message-box">
            회원 탈퇴 후 30일 내에 탈퇴 취소를 신청하실 경우에는 <br />
            <strong>고객센터(1688-1011)</strong> 로 문의해주시기 바랍니다.
          </MessageBox>
        </div>
        <ButtonGroup>
          <Link to="/">
            <Button>확인</Button>
          </Link>
        </ButtonGroup>
      </PageContainer>
    );
  }
}
